var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.493,
    height: 28.3,
    viewBox: "0 0 27.493 28.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-svgrepo-com",
    transform: "translate(-6.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(6.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M176.982,13.794V.8a.8.8,0,0,0-1.591,0v13a4.039,4.039,0,0,0,0,7.919V27.5a.8.8,0,1,0,1.591,0V21.713a4.039,4.039,0,0,0,0-7.919Zm-.8,6.4a2.445,2.445,0,1,1,2.445-2.445A2.447,2.447,0,0,1,176.186,20.2Z",
    transform: "translate(-162.41 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M11.682,7.124V.8a.8.8,0,0,0-1.591,0V7.124a4.039,4.039,0,0,0,0,7.919V27.5a.8.8,0,1,0,1.591,0V15.037a4.036,4.036,0,0,0,0-7.913Zm-.8,6.4a2.445,2.445,0,1,1,2.445-2.445A2.447,2.447,0,0,1,10.886,13.528Z",
    transform: "translate(-6.85 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M341.282,7.124V.8a.8.8,0,0,0-1.591,0V7.124a4.039,4.039,0,0,0,0,7.919V27.5a.8.8,0,1,0,1.591,0V15.037a4.036,4.036,0,0,0,0-7.913Zm-.8,6.4a2.445,2.445,0,1,1,2.445-2.445A2.447,2.447,0,0,1,340.486,13.528Z",
    transform: "translate(-317.029 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e5f0e8ac939e1c951c0c495aac39f15d.svg";
export { ForwardRef as ReactComponent };